import firebase from 'firebase/app';
import 'firebase/auth';
import firebaseConfig from './config/firebase';

firebase.initializeApp(firebaseConfig);

export const firebaseAuth = firebase.auth();
export const googleProvider = new firebase.auth.GoogleAuthProvider();
